import * as React from 'react';

import * as Icons from '../../../icons';
import { Styled } from './styled';

export const DeleteButton = (props) => {
  const { onClick } = props;
  return (
    <Styled.Container onClick={onClick}>
      <Icons.CloseSmall />
    </Styled.Container>
  );
};
